import { basicModalEmits, basicModalProps } from "../../../../../hooks/useModalToggle";
import { dayjs } from "element-plus";
import { PropType } from "vue";

export const dateSettingProps = {
  ...basicModalProps,
  form: {
    type: Object as PropType<any>,
    default: () => ({}),
  },
  data: {
    type: Object as PropType<any>,
    default: () => ({}),
  },
  refreshTable: {
    type: Function,
    default: null,
  },
};

export const dateSettingEmits = {
  ...basicModalEmits,
  "update:form": (form: any) => form,
};

export enum DateSettingType {
  LongValid = "longValid",
  OneDay = "oneDay",
  ThreeDay = "threeDay",
  SixMonth = "sixMonth",
  OneYear = "oneYear",
  TwoYear = "twoYear",
  FiveYear = "fiveYear",
  TenYear = "tenYear",
  DateCustom = "dateCustom",
}

export const dateSelectList = [
  {
    label: "长期有效",
    value: DateSettingType.LongValid,
    callback: () => {
      return {
        startTime: null,
        endTime: null,
      };
    },
  },
  {
    label: "一天",
    value: DateSettingType.OneDay,
    callback: () => {
      return {
        startTime: dayjs().startOf("day").format("YYYY/MM/DD"),
        endTime: dayjs().endOf("day").format("YYYY/MM/DD"),
      };
    },
  },
  {
    label: "三天",
    value: DateSettingType.ThreeDay,
    callback: () => {
      return {
        startTime: dayjs().startOf("day").format("YYYY/MM/DD"),
        endTime: dayjs().add(3, "day").endOf("day").format("YYYY/MM/DD"),
      };
    },
  },
  {
    label: "六个月",
    value: DateSettingType.SixMonth,
    callback: () => {
      return {
        startTime: dayjs().startOf("day").format("YYYY/MM/DD"),
        endTime: dayjs().add(6, "month").endOf("day").format("YYYY/MM/DD"),
      };
    },
  },
  {
    label: "一年",
    value: DateSettingType.OneYear,
    callback: () => {
      return {
        startTime: dayjs().startOf("day").format("YYYY/MM/DD"),
        endTime: dayjs().add(1, "year").endOf("day").format("YYYY/MM/DD"),
      };
    },
  },
  {
    label: "两年",
    value: DateSettingType.TwoYear,
    callback: () => {
      return {
        startTime: dayjs().startOf("day").format("YYYY/MM/DD"),
        endTime: dayjs().add(2, "year").endOf("day").format("YYYY/MM/DD"),
      };
    },
  },
  {
    label: "五年",
    value: DateSettingType.FiveYear,
    callback: () => {
      return {
        startTime: dayjs().startOf("day").format("YYYY/MM/DD"),
        endTime: dayjs().add(5, "year").endOf("day").format("YYYY/MM/DD"),
      };
    },
  },
  {
    label: "十年",
    value: DateSettingType.TenYear,
    callback: () => {
      return {
        startTime: dayjs().startOf("day").format("YYYY/MM/DD"),
        endTime: dayjs().add(10, "year").endOf("day").format("YYYY/MM/DD"),
      };
    },
  },
  {
    label: "自定义",
    value: DateSettingType.DateCustom,
    callback: () => {
      return {
        startTime: null,
        endTime: null,
      };
    },
  },
];

export const dateSelectListMap = dateSelectList.reduce<Record<string, (typeof dateSelectList)[0]>>(
  (map, item) => {
    map[item.value] = item;
    return map;
  },
  {},
);
